import {HolidayEnum} from "../enums/holidayEnum";

export function pickSeasonalThemeByDate(d = new Date()) {
    const m = d.getMonth() + 1;
    const day = d.getDate();

    if ((m === 10 && day >= 17) || (m === 11 && day <= 2)) return HolidayEnum.halloween;

    return HolidayEnum.base;
}
